export const API_ADDRESS = process.env.API_ADDRESS ?? '';
export const API_SKIP_AUTH = process.env.API_SKIP_AUTH ?? false;
export const API_FULL_STYLE_ENDPOINT = process.env.API_FULL_STYLE_ENDPOINT ?? '';

export const getApiAddress = (): string => {
  return API_ADDRESS;
};

export const getApiSkipAuth = (): boolean => {
  return API_SKIP_AUTH === 'true';
};

export const getApiFullStyleEndpoint = (): string => {
  return API_FULL_STYLE_ENDPOINT;
};
